<template>
    <div class="worker__checkboxes">
        <div class="item">
            <input @change="change" v-model="valueModel" value="0" type="radio" :id="`no-access${index}-user${indexUser}`" :name="`access-checkbox${index}-user${indexUser}`">
            <label :for="`no-access${index}-user${indexUser}`"></label>
        </div>
        <div class="item">
            <input @change="change" v-model="valueModel" value="1" type="radio" :id="`read-access${index}-user${indexUser}`" :name="`access-checkbox${index}-user${indexUser}`">
            <label :for="`read-access${index}-user${indexUser}`"></label>
        </div>
        <div class="item">
            <input @change="change" v-model="valueModel" value="2" type="radio" :id="`edit-access${index}-user${indexUser}`" :name="`access-checkbox${index}-user${indexUser}`">
            <label :for="`edit-access${index}-user${indexUser}`"></label>
        </div>
    </div>
</template>

<script>
export default {
    name: "RightRadioSelect",
    props: {
        value: {default: ''},
        index: {default: ''},
        indexUser: {default: ''},
    },
    data(){
        return  {
            valueModel: ''
        }
    },
    mounted() {
        this.valueModel = this.value
    },
    watch: {
        value(){
            this.valueModel = this.value
        }
    },
    methods: {
        change(){
            this.$emit('change', this.valueModel);
        }
    }
}
</script>

<style scoped>

</style>